import React from 'react';
import { Tabs } from 'antd';

import PillarOneOverviewGuide from './PillarOneOverviewGuide';
import PillarOneRestraintGuide from './PillarOneRestraintGuide';
import PillarOneSliderDirectionGuide from './PillarOneSliderDirectionGuide';
import PillarOneSliderMagnitudeGuide from './PillarOneSliderMagnitudeGuide';

type Props = {
  newsMapping: (active: boolean) => React.ReactNode;
  sliderDirection: (active: boolean) => React.ReactNode;
  sliderMagnitude: (active: boolean) => React.ReactNode;
  restraint: (active: boolean) => React.ReactNode;
};

const PillarOneComponentTabs: React.FC<Props> = ({
  newsMapping,
  restraint,
  sliderDirection,
  sliderMagnitude,
}) => {
  const [activeKey, setActiveKey] = React.useState('overview');

  return (
    <Tabs
      activeKey={activeKey}
      className="assessment-inspect-assessment__pillar-one-component-tabs"
      items={[
        {
          key: 'overview',
          label: 'Pillar 1 overview',
          children: (
            <div className="assessment-inspect-assessment__detail-panel assessment-inspect-assessment__detail-panel--pillar-one">
              <section
                aria-label="Pillar 1 overview workspace"
                className="assessment-inspect-assessment__pillar-one-component-empty"
              />
              <PillarOneOverviewGuide />
            </div>
          ),
        },
        {
          key: 'news-mapping',
          label: 'News-mapping(40%)',
          forceRender: true,
          children: newsMapping(activeKey === 'news-mapping'),
        },
        {
          key: 'slider-direction',
          label: 'Slider direction(25%)',
          children: (
            <div className="assessment-inspect-assessment__detail-panel assessment-inspect-assessment__detail-panel--pillar-one">
              <section
                aria-label="Slider direction workspace"
                className="assessment-inspect-assessment__pillar-one-workspace"
              >
                {sliderDirection(activeKey === 'slider-direction')}
              </section>
              <PillarOneSliderDirectionGuide />
            </div>
          ),
        },
        {
          key: 'slider-magnitude',
          label: 'Slider magnitude(25%)',
          children: (
            <div className="assessment-inspect-assessment__detail-panel assessment-inspect-assessment__detail-panel--pillar-one">
              <section
                aria-label="Slider magnitude workspace"
                className="assessment-inspect-assessment__pillar-one-workspace"
              >
                {sliderMagnitude(activeKey === 'slider-magnitude')}
              </section>
              <PillarOneSliderMagnitudeGuide />
            </div>
          ),
        },
        {
          key: 'fourth-component',
          label: 'Restraint when unclear(10%)',
          children: (
            <div className="assessment-inspect-assessment__detail-panel assessment-inspect-assessment__detail-panel--pillar-one">
              <section
                aria-label="Restraint when unclear workspace"
                className="assessment-inspect-assessment__pillar-one-workspace"
              >
                {restraint(activeKey === 'fourth-component')}
              </section>
              <PillarOneRestraintGuide />
            </div>
          ),
        },
      ]}
      onChange={setActiveKey}
    />
  );
};

export default PillarOneComponentTabs;
